import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  changeFieldQuizChangeAsk,
  changeFieldQuizDeleteAsk,
  changeFieldQuizAddAnswer
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import {
  selectFieldQuiz,
  selectFieldQuizAsk,
  selectFieldQuizAnswers,
  selectQuizAskErrorByKey,
  selectAllErrors
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';
import { t } from 'utils/translates';
import connect from 'react-redux/es/connect/connect';
import _ from 'lodash';
import QuizAscAnswerInput from './_QuizAscAnswerInput';

class QuizAscInput extends Component {
  constructor(props) {
    super(props);
    this.inputName = `${props.fieldQuiz.field}_${props.keyAsk}`;
    this.inputRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (_.isEmpty(prevProps.allErrors) && !_.isEmpty(this.props.allErrors)) {
      const firstErrorField = Object.keys(this.props.allErrors)[0];
      if (firstErrorField.includes(this.inputName)) {
        this.inputRef.current.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }

  render() {
    const hasErrorQuizAsk = keyAsk =>
      this.props.selectQuizAskErrorByKey(keyAsk);
    const errorQuizAskDesc = keyAsk => {
      if (this.props.selectQuizAskErrorByKey(keyAsk)) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {this.props.selectQuizAskErrorByKey(keyAsk)[0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    const num = this.props.keyAsk + 1;
    return (
      <React.Fragment>
        <div className="panel panel-heading_padding-large panel-default m-b-20">
          <div className="panel-heading panel-inner-border-bottom">
            <div className="media full-width">
              <div className="media-body media-middle full-width">
                <h3 className="panel-title">
                  <i className="fa fa-comments" /> {t('Вопрос-Ответы')} #{num}
                </h3>
              </div>
              {this.props.fieldQuiz.value.length > 1 ? (
                <div className="media-right media-middle text-overflow">
                  <button
                    className="btn btn-default"
                    type="button"
                    onClick={() =>
                      this.props.changeFieldQuizDeleteAsk(this.props.keyAsk)
                    }
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              ) : null}
            </div>
          </div>
          <div className="panel-body">
            <div
              className={`form-group ${
                hasErrorQuizAsk(this.props.keyAsk) ? 'has-error' : ''
              }`}
            >
              <label className="control-label" htmlFor={'ask1'}>
                {t('Вопрос')}
              </label>
              <input
                ref={this.inputRef}
                className="form-control"
                placeholder={t('Вопрос для проверки выполнения задания')}
                type="text"
                id="ask1"
                onChange={e =>
                  this.props.changeFieldQuizChangeAsk({
                    keyAsk: this.props.keyAsk,
                    value: e.target.value
                  })
                }
                value={this.props.fieldQuizAskByKey(this.props.keyAsk)}
              />
              {errorQuizAskDesc(this.props.keyAsk)}
            </div>
            {this.props
              .fieldQuizAnswersByKey(this.props.keyAsk)
              .map((valueAnswer, keyAnswer) => (
                <QuizAscAnswerInput
                  key={`QuizAscAnswerInput${keyAnswer + 1}`}
                  reducerName={this.props.reducerName}
                  keyAsk={this.props.keyAsk}
                  keyAnswer={keyAnswer}
                  valueAnswer={valueAnswer}
                />
              ))}
            <div className="form-group m-b-0">
              <button
                className="btn btn-default"
                type="button"
                onClick={() => {
                  this.props.changeFieldQuizAddAnswer(this.props.keyAsk);
                }}
              >
                <i className="fa fa-plus" /> {t('Добавить вариант ответа')}
              </button>
              <small className="help-block m-b-0">
                {t('Чем больше вариантов ответа, тем лучше (безопасней)')}
              </small>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

QuizAscInput.propTypes = {
  // IN
  reducerName: PropTypes.string.isRequired,
  keyAsk: PropTypes.number.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  fieldQuiz: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  allErrors: PropTypes.shape({}).isRequired,
  fieldQuizAskByKey: PropTypes.func.isRequired,
  fieldQuizAnswersByKey: PropTypes.func.isRequired,

  selectQuizAskErrorByKey: PropTypes.func.isRequired,

  changeFieldQuizChangeAsk: PropTypes.func.isRequired,
  changeFieldQuizDeleteAsk: PropTypes.func.isRequired,
  changeFieldQuizAddAnswer: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  fieldQuiz: selectFieldQuiz(state, props.reducerName),
  allErrors: selectAllErrors(state, props.reducerName),
  fieldQuizAskByKey: key => selectFieldQuizAsk(state, props.reducerName, key),
  fieldQuizAnswersByKey: key =>
    selectFieldQuizAnswers(state, props.reducerName, key),
  selectQuizAskErrorByKey: keyAsk =>
    selectQuizAskErrorByKey(state, props.reducerName, keyAsk)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldQuizChangeAsk: value =>
    dispatch(changeFieldQuizChangeAsk(props.reducerName, value)),
  changeFieldQuizDeleteAsk: keyAsk =>
    dispatch(changeFieldQuizDeleteAsk(props.reducerName, keyAsk)),
  changeFieldQuizAddAnswer: keyAsk =>
    dispatch(changeFieldQuizAddAnswer(props.reducerName, { keyAsk }))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuizAscInput);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/CheckTaskInputs/CheckTypeQuiz/QuizAscInput/QuizAscInput.js